<template>
  <div
    class="tw:flex-col tw:flex tw:w-full tw:md:max-w-(--tw-breakpoint-lg) tw:lg:max-w-(--tw-breakpoint-xl) tw:mr-auto tw:ml-auto tw:min-h-screen-minus-footer tw:mb-10"
  >
    <div class="tw:w-auto tw:lg:w-[827px] tw:mx-3.5 tw:lg:mx-auto tw:mt-8">
      <div class="tw:flex tw:flex-col tw:align-start tw:mb-8">
        <p class="tw:text-xl tw:font-bold">{{ 'Admin tool' }}</p>
      </div>
      <AdminTool />
    </div>
  </div>
</template>
<script setup lang="ts">
import AdminTool from '@/components/adminTool/AdminTool.vue'
</script>
